// tslint:disable:max-classes-per-file
import { User, UserLoginRequest } from '@atmi/core/models';
import { Action } from '@atmi/core/models/actions';

export const enum UserTypeActions {
  INIT = '[User] Init',
  LOGIN = '[User] Login',
  LOGOUT = '[User] Logout',
  UPDATE_INFO = '[User] Update info',
  CHANGE_PASSWORD = '[User] Change password',
}

export class LoginAction implements Action {
  readonly type = UserTypeActions.LOGIN;
  constructor(readonly payload: { user: UserLoginRequest }) { }
}

export class LogoutAction implements Action {
  readonly type = UserTypeActions.LOGOUT;
}

export class UpdateInfoAction implements Action {
  readonly type = UserTypeActions.UPDATE_INFO;
  constructor(readonly payload: { user: User }) { }
}

export class ChangePasswordAction implements Action {
  readonly type = UserTypeActions.CHANGE_PASSWORD;
  constructor(readonly payload: { user: User }) { }
}

export type UserActions =
  LoginAction |
  LogoutAction |
  UpdateInfoAction |
  ChangePasswordAction;
